module.exports = __webpack_public_path__ + "img/6.5a160706.jpg";